import { unique } from "../../../../utilities/unique.ts";
import type { DimensionDictionary } from "../../../../../../../../api/types/svTypes.ts";

export function getNewSelection(rowNumbers: number[], values: DimensionDictionary[], keyField: string) {
  return values
    .filter((row) => rowNumbers.includes(row["id"] as number))
    .map((row) => row[keyField])
    .filter((v): v is string => v !== undefined)
    .filter(unique);
}
